import { useState, useMemo } from 'react'

interface ReturnType<T> {
  query: string
  setQuery: (val: string) => void
  results: T[]
}

export function useSearchSettings<T>(
  data: T[],
  {
    keys,
    sort
  }: {
    keys: (keyof T)[]
    sort?: (results: T[]) => T[]
  }
): ReturnType<T> {
  const [query, setQuery] = useState('')

  const results = useMemo(() => {
    const filtered = !query.trim()
      ? data
      : data.filter(item =>
          keys.some(key =>
            String(item[key] ?? '')
              .toLowerCase()
              .includes(query.toLowerCase())
          )
        )

    return sort ? sort(filtered) : filtered
  }, [query, data, keys, sort])

  return { query, setQuery, results }
}
